import { defineStore } from 'pinia'
import {computed, ref} from 'vue'
import { useGlobalStore } from '@/stores/index'
import api from '@/api';

export const useTracePartsStore = defineStore('traceParts', () =>
{
    const apiBase = window.app.partnumber_search_extended.trace_parts.api_base
    const viewerBase = window.app.partnumber_search_extended.trace_parts.viewer_base
    const classificationID = window.app.partnumber_search_extended.trace_parts.classification_id
    const elsId = window.app.partnumber_search_extended.trace_parts.els_Id
    const bearerToken = window.app.partnumber_search_extended.trace_parts.bearer_token
    const globals = useGlobalStore()
    const tracePartDownloadActive = ref(false)

    let cadInformation = ref({
        viewer3dAvailableId: '',
        cadFormatAvailable: false,
        cadList: [],
        activeCadItem: '',
        viewer3dAvailable: false,
    })

    const apiUrlGetTracePartsCADdataAvailabilityPath = computed(() =>
    {
        return apiBase + '/v3/Product/CadDataAvailability?cultureInfo=' + globals.languageIsocode + '&classificationCode=' + classificationID
    })

    const apiUrlGetTraceParts3dPath = computed(() =>
    {
        return viewerBase + '/odu/' + globals.languageIsocode + '/api/viewer/3d?SupplierID=' + elsId + '&PartNumber=' + cadInformation.value.viewer3dAvailableId
    })

    const apiUrlGetTraceDownloadCatalogPath = computed(() =>
    {
        return apiBase + '/v3/Product/cadFileUrl'
    })

    const tracepartHeader = computed(() =>
    {
        return {
            headers: {
                authorization: 'Bearer ' + bearerToken,
            }
        }
    })

    async function getCadFormatAvailable (id) {
        const url = new URL(apiUrlGetTracePartsCADdataAvailabilityPath.value + '&partNumber='+ id)
        await api.get(url, tracepartHeader.value)
            .then(response =>
            {
                cadInformation.value.cadFormatAvailable = response.data.partNumberAvailability.availability
                cadInformation.value.viewer3dAvailable = response.data.viewerAvailability
                cadInformation.value.viewer3dAvailableId = response.data.partNumberAvailability.partNumber
                if (cadInformation.value.cadFormatAvailable)
                {
                    cadInformation.value.cadList = response.data.cadFormatList
                }
            }).catch(() => {
            })
    }

    async function downloadActiveCadItem (id) {
        if (cadInformation.value.activeCadItem) {
            const file = cadInformation.value.cadList.filter(el => el.cadFormatId === cadInformation.value.activeCadItem)
            if (window.dataLayer) {
                window.dataLayer.push({
                    'download-file': file[0].cadFormatName,
                    'download-part': id,
                    'event': 'Download'
                })
            }
            tracePartDownloadActive.value = true
            let cadRequestId = ''
            // get cadRequestId
            const options = {
                "userEmail": "noreply@odu-connectors.com",
                "cultureInfo": globals.languageIsocode,
                "cadFormatId": cadInformation.value.activeCadItem,
                "partNumber": id,
                "classificationCode": classificationID
            }
            await api.post(apiBase + '/v3/Product/cadRequest', options, tracepartHeader.value)
                .then(response =>
                {
                    cadRequestId = response.data
                })

            try {
              const fileUrl = await pollForCadFileUrl(cadRequestId);
              window.open(fileUrl);
            } catch (error) {
              console.error('Fehler beim Abrufen der CAD-Datei:', error);
            } finally {
              tracePartDownloadActive.value = false;
            }
        }

    }

  async function pollForCadFileUrl(cadRequestId, maxAttempts = 10, delayMs = 1000) {
    const url = new URL(apiBase + '/v2/Product/cadFileUrl?cadRequestId=' + cadRequestId);

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        const response = await api.get(url, tracepartHeader.value);

        if (response.status === 200) {
          return response.data;
        }

        await new Promise(resolve => setTimeout(resolve, delayMs));

        delayMs = Math.min(delayMs * 1.5, 10000);

      } catch (error) {
        if (error.response && error.response.status !== 204) {
          throw error;
        }

        await new Promise(resolve => setTimeout(resolve, delayMs));
      }
    }

    throw new Error('Maximale Anzahl von Versuchen erreicht. CAD-Datei nicht verfügbar.');
  }


  function clearItem () {
        cadInformation.value = {
            viewer3dAvailableId: '',
            cadFormatAvailable: false,
            cadList: [],
            activeCadItem: '',
            viewer3dAvailable: false
        }
    }

    return {
        getCadFormatAvailable,
        downloadActiveCadItem,
        cadInformation,
        apiUrlGetTraceParts3dPath,
        clearItem,
        tracePartDownloadActive,
        apiUrlGetTraceDownloadCatalogPath
    }
})
